import React from "react";
import Navbar from "../Components/Navbar";
import DateHelpers from "../Helper/DateHelpers";
import AdminRegistrationCardList from "../Components/AdminRegistrationCardList";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Session from 'react-session-api';
import Footer from "../Components/Footer";
import '../Styles/AccountSearch.scss';
import { Helmet } from "react-helmet";
import AdminRegistrationCard from "../Components/AdminRegistrationCard";
import EventReporting from "./EventReporting";
import AccountCardList from "../Components/AccountCardList";

function AccountSearch() {

   const [queriedAccounts, setQueriedAccounts] = useState()
   const [searchSelection, setSearchSelection] = useState('')

   async function getAccounts() {
      try {

         const accountResponse = await fetch('/getaccounts', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ queriedAccounts })
         })

         var accounts = await accountResponse.json()
         console.log("Here's accounts", accounts)
         setQueriedAccounts(accounts.data.account)
      }
      catch (error) {
         console.log(error)
      }
   }


   useEffect(() => {
      getAccounts()
   }, [])

   useEffect(() => {
      if(!queriedAccounts)
      {
         return
      }

      console.log("Here's queried accounts!", queriedAccounts)
   }, [queriedAccounts])

   return (
      <div className='accountSearchContainer'>
         <div className="accountSearchContent">
            <div className="accountSearchContentHeading">
               Account Search
            </div>
            <div className="accountSearchContentCards">
               <AccountCardList
                  queriedAccounts={queriedAccounts} />
            </div>
         </div>
      </div>
   )
}
export default AccountSearch;